import { useLocation } from 'react-router-dom'

export default function useQuery() {
  //Tag for tab
  const hash = window.location.hash
  return new URLSearchParams(useLocation().search + hash)
}
